import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../../services/AuthService';

export const landingRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.authReady()) {
    return authService.isAuthenticated() ? router.parseUrl('/home') : true;
  }

  return authService.authReady$.pipe(
    filter(ready => ready),
    take(1),
    map(() => {
      if (authService.isAuthenticated()) {
        return router.parseUrl('/home');
      }
      return true;
    })
  );
};
